const ControlManagerConfig = {
    defaults: {
        navbar: {
          display: true,
          folded: false,
          position: 'left',
        },
        toolbar: {
          display: true,
          style: 'fixed',
        },
        footer: {
          display: false,
          style: 'fixed',
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      }
}
export default ControlManagerConfig